import React, { useEffect } from "react";
import Banner from "../CommonComponents/Banner";
import ContactForm from "../CommonComponents/ContactForm";
import HomeMapSection from "../Components/HomeMapSection";
import TnsReady from "../Components/TnsReady";

function ContactPage() {
   useEffect(() => {
    const element = document.getElementById("contact-form");

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);
  return (
    <>
      <Banner
        backgroundImage="/assets/contact-banner.png"
        label="Contact Us"
        heading={
          <>
            Get in Touch with <br />
          </>
        }
        heading2="TNS Global"
        text={
          <>
            Get in touch with our experts to explore the right travel technology solutions for your business.
          </>
        }

        // buttons={[
        //     { text: "Explore Solutions", variant: "primary", onClick: () => alert("Explore clicked") }
        // ]}
      />
      <ContactForm isContactPage={true} />
      <HomeMapSection />
      <TnsReady />
    </>
  );
}

export default ContactPage;
